import BigNumber from 'bignumber.js';

import { useTimeframe } from 'modules/chains/components/TimeframeProvider';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { NetworkUsageCard } from '../NetworkUsageCard';
import { averageRequestsCardTranslation } from './translation';
import { getRequestsAverage } from './utils/getRequestsAverage';
import { useStats } from '../StatsProvider';

interface AverageRequestsCardProps {
  className?: string;
  disabled?: boolean;
}

export const AverageRequestsCard = ({
  className,
  disabled,
}: AverageRequestsCardProps) => {
  const { keys, t } = useTranslation(averageRequestsCardTranslation);

  const { timeframe } = useTimeframe();

  const { loading, totalRequests } = useStats();

  return (
    <NetworkUsageCard
      className={className}
      disabled={disabled}
      loading={loading}
      title={t(keys.title)}
      value={getRequestsAverage(new BigNumber(totalRequests), timeframe)}
    />
  );
};
